import React from "react";
import "./layouts.css";
import config from '../../../helper/config';
import {customerConstants} from "../../../helper/constants.js";
import Terms from '../../../pages/manage/terms-and-conditions/cmc/TermsAndConditions.js';
import { publicAssestsPath } from "../../../helper/namespace.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const setPathPerUserType = () => {
  const userType = sessionStorage.getItem('userType')
  const customer = getCustomerFeatureFlag();
  let pdfPath = ''
  if(customer === customerConstants.EDF_CUSTOMER3)
  switch (userType) {
    case 'admin':
      pdfPath = publicAssestsPath.TERM_AND_CONDITION.EDFOCI_CGC_ADMIN
      break;
    case 'cgc_student':
      pdfPath = publicAssestsPath.TERM_AND_CONDITION.EDFOCI_CGC_STUDENT      
      break;
    case 'teacher':
      pdfPath = publicAssestsPath.TERM_AND_CONDITION.EDFOCI_CGC_TEACHER    
      break;  
    default:
      break;

  }
  return pdfPath
}

export default function Footer(props) {
    const customer = getCustomerFeatureFlag();
    let footerText;
    switch (customer) {
      case customerConstants.EXO_CUSTOMER1:
        footerText = "© 2024 Edsider. All Right Reserved. Designed and Developed by Infinity Innovators (Pvt) Ltd"
        break;
      case customerConstants.EXO_CUSTOMER2:
        footerText = "© 2024 All Rights Reserved. Powered by EdSider Supported by Infinity Innovators (Pvt) Ltd"
        break;
      default:
        footerText = "© 2024 All Rights Reserved. Designed and Developed by Infinity Innovators (Pvt) Ltd"
        break;
    }
  return (
    <div className="footer bg-white py-4 " id="footer">

      <div className="container-fluid" style={{display:'flex', justifyContent:'space-between'}}>
        <span className="text-dark-75">
         {footerText}         
        </span>
        <span className="text-dark-75" style={{cursor:'pointer'}} onClick={() => window.open(setPathPerUserType(), '_blank')}>
          Terms & Conditions
        </span>
      </div>
    </div>
  );
}
